import React from 'react';
import DayPicker from 'react-day-picker';
import dateformat from 'dateformat';
import {redirectToFunnel} from '../../../../SEOContainer/Common/utils/redirectToFunnel'

export default class RangeCalView extends React.Component {
    static defaultProps = {
        numberOfMonths: 2,
    };

    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleResetClick = this.handleResetClick.bind(this);
        this.resetToState = this.resetToState.bind(this);
        // this.handleRangeSelection = this.handleRangeSelection.bind(this);
        this.handleSingleSelection = this.handleSingleSelection.bind(this);
        this.callAndRemoaveToast = this.callAndRemoaveToast.bind(this);
        this.state = this.getInitialState();
    }

    getInitialState() {
        return {
            from: undefined,
            // to: undefined,
            level: 'danger',
            showToast: false,
            message: 'Custom error if days exceeding 30 days',
            loading: true,
            showWarningInfoBar: true,
            showSuccessInfoBar: true,
            showPriceIncreaseInfoBar: true,
        };
    }

    componentDidMount() {
        this.customizingYear();
        setTimeout(() => {
            this.setState({loading: false})
        }, 3000);
    }

    callAndRemoaveToast() {
        this.setState({
            showToast: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showToast: false
                })
            }, 1500)
        })
    }

    customizingYear() {
        let labelTxt = '';
        let className = '.rangeCalView' + '.DayPicker-Caption div'
        let elem = document.querySelectorAll(className);
        if (elem && elem.length > 0) {
            for (let i = 0; i < elem.length; i++) {
                if (i === 0) {
                    labelTxt = ""
                } else {
                    labelTxt = ""
                }
                let tempYr = elem[i].innerText.split(' ')[1].replace(/\s/g, "");
                let correctedYr = elem[i].innerText.split(' ')[0] + '' + '<span class="customYear">' + tempYr + '</span>' + labelTxt;
                elem[i].innerHTML = correctedYr
            }
        }
    }

    resetToState() {
        if (this.props.activeTb == 1) {
            this.props.setActiveTab && this.props.setActiveTab(0);
        } else {
            return
        }
    }

    handleSingleSelection(day) {
        const { moveToFunnelParams, page, isBusCard } = this.props
        this.setState({
            from: day
        })
        let date = dateformat(day, 'yyyymmdd')
        redirectToFunnel({ page: page, data: { ...moveToFunnelParams }, data_date: date });
    }

    dayDiff(date1, date2) {
        // To calculate the time difference of two dates 
        var Difference_In_Time = date2.getTime() - date1.getTime(); 
        // To calculate the no. of days between two dates 
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 
        return Difference_In_Days;
    }

    handleDayClick(day, modifiers = {}) {
        let from = this.state.from;
        // let to = this.state.to;
        if (modifiers.disabled) {
            return;
        }
        if (this.props.activeTb == 0) {
            this.handleSingleSelection(day);
        } else {
            this.handleSingleSelection(day);
        }
    }

    handleResetClick() {
        this.setState(this.getInitialState());
    }

    render() {
        const { from,  level, message, showToast, loading, showWarningInfoBar, showSuccessInfoBar, showPriceIncreaseInfoBar } = this.state;
        const { activeTb, setActiveTab, lobName, dayAdditionalData  } = this.props;
        let modifiers = {}
        // if(from) var tomorrow = new Date(from.getTime() + (1000 * 60 * 60 * 24));
        if (activeTb === 0) {
            modifiers = { start: from };
        } else {
            modifiers = { start: from};
        }
        return (
            <div className={`rangeCalView ${lobName ? lobName : ''}`}>
                <div className="rangeCalView__dates">
                    <div className="rangeCalView__dates--dayName">
                        <span>Mon</span>
                        <span>Tue</span>
                        <span>Wed</span>
                        <span>Thu</span>
                        <span>Fri</span>
                        <span>Sat</span>
                        <span>Sun</span>
                    </div>
                </div>
                <div className="RangeExample">
                    <DayPicker
                        className="Selectable"
                        firstDayOfWeek={1}
                        month={new Date()}
                        modifiers={modifiers}
                        onDayClick={this.handleDayClick}
                        selectedDays={[from] }
                        weekdayElement={() => <span></span>}
                        numberOfMonths={3}
                        disabledDays={{before: new Date()}}
                    />
                </div>
            </div>
        );
    }
}